import type { ReactNode } from 'react';

export const symbol_speed_0_75: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M600-277q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h140v-115H600q-12.75 0-21.37-8.63Q570-469.25 570-482v-171q0-12.75 8.63-21.38Q587.25-683 600-683h170q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H630v111h110q24 0 42 18t18 42v115q0 24-18 42t-42 18H600ZM435-623H295q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h140q24 0 42 16t18 40q0 3-2 13l-84 315q-2 10-10 15.5t-18.32 5.5q-14 0-22.84-11T353-314l82-309ZM208.5-285.68q-8.5-8.67-8.5-21.5 0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.68 8.5 8.67 8.5 21.5 0 12.82-8.68 21.32-8.67 8.5-21.5 8.5-12.82 0-21.32-8.68Z"
		/>
	</svg>
);
